module.exports = __webpack_public_path__ + "img/sun.5f297943.svg";